import './header.css';
import {versao} from '../../services/versao.jsx';

function Header(props) {
    return(

      <div className="div-header" 
            style={{display:'flex',
                    backgroundColor:'#2957A4',
                    width:'100%',
                    height:'6vh'}}>

        <div className="div-header-logo" 
              style={{display:'flex',
                      height:'80%',
                      alignItems:'center',
                      verticalAlign:'auto',
                      padding:'auto',
                      marginLeft:'1rem',
                      marginTop:'0.5rem',
                      width:'80%'}}>

          <h3 style={{color:'aliceblue'}}>{props.title}</h3>

        </div>

        <div className="div-header-versao" 
              style={{display:'flex',
                      color:'aliceblue',
                      alignItems:'center',
                      borderRadius:'0.6rem',
                      width:'20%'}}>

            {/* DIV - Desenvolvimento **** retirar em produção **** 

            <div style={{backgroundColor:'red',
                         margin:'auto',
                         width:'65px',
                         textAlign:'center',
                         borderRadius:'0.5rem'}}>
              Teste
            </div>
            
             */}

            {/* Versão *** retornar em produção */}

            <span style={{fontSize:'small',
                        width:'100%',
                        textAlign:'right',
                        marginRight:'1rem'}}>
              {versao}
            </span>

            {/* */}
        </div>

      </div>

  )
}

export default Header;

